<template>
  <div style="clear: left;">
      <div class="page-list">
        <span v-for="(_, index) in summaries" :key="index" :class="index === selectedSummary ? 'selected' : 'selector'" @click="selectSummary(index)">{{ index + 1 }}</span>
      </div>
      <Summary v-for="(summary, index) in summaries" :key="index" :summary="summary" :class="index === selectedSummary ? '' : 'hide'"/>
  </div>
</template>

<script>
import Summary from './Summary.vue';

export default {
  name: 'DailySummary',
  components: {
    Summary,
  },
  data: function() {
    return {
      selectedSummary: 0,
    };
  },
  methods: {
    selectSummary: function(index) {
      this.selectedSummary = index;
    },
  },
  props: ['summaries'],
}
</script>

<style scoped>
.hide {
  display: none;
}

.page-list {
  text-align: center;
}

.selected {
  margin: 2px;
  font-weight: bold;
}

.selector {
  margin: 2px;
}
</style>
